/* src/app/private/components/admission/admission-profile/admission-profile.component.scss */
.avatar-url {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  border-width: 6px;
  border-color: var(--primary-color);
}
.bottom-buttons {
  background-color: var(--p-card-background);
  width: 93%;
  bottom: 0px;
  border-bottom-right-radius: 5px;
  padding-bottom: 10px;
  padding-top: 10px;
}
.action-icon {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;
  background-color: var(--secondry-light-gray);
  border-radius: 50%;
  padding: 5px;
  height: 26px;
  width: 26px;
  font-weight: 600;
}
.action-icon i {
  font-size: 12px !important;
}
.divider {
  color: var(--secondry-dark-gray);
}
.profile-select {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.profile-container {
  overflow-x: auto;
  overflow-y: hidden;
  height: 92vh;
}
/*# sourceMappingURL=admission-profile.component.css.map */
